(function () {
  const TOKYO_TZ = 'Asia/Tokyo';
  const HOLIDAY_CACHE_PREFIX = 'eunchang-holidays-v2:';
  const HOLIDAY_SET_PROMISE_CACHE = new Map();
  const ORDER_CUTOFF_HOUR = 15;
  const SCRIPT_VERSION = 'sample3-v4-stuckfix-20260623';

  /**
   * 기존 태그 기반 룰 유지
   */
  const TAG_RULES = [
    {
      code: 'FUSEN_DIECUT_20',
      days: 20,
      imageRequired: true,
      tags: ['型抜きふせん'],
    },
    {
      code: 'FUSEN_SMALLLOT_15',
      days: 15,
      imageRequired: true,
      tags: ['小ロットショップ'],
    },
    {
      code: 'FUSEN_STANDARD_14',
      days: 14,
      imageRequired: true,
      tags: ['一般付箋', 'カバー付き付箋', '台紙付箋'],
    },
  ];

  /**
   * custom.shipping_rule_key 우선 룰
   * 상품별로 아래 키를 메타필드에 넣어서 사용
   */
  const SHIPPING_RULE_KEY_RULES = {
    'adpapper-copy-option': {
      code: 'ADPAPPER_COPY_OPTION',
      days: 9,
      imageRequired: false,
      reason: 'shipping_rule_key',
    },
    'adpapper-copy-no-option': {
      code: 'ADPAPPER_COPY_NO_OPTION',
      days: 7,
      imageRequired: false,
      reason: 'shipping_rule_key',
    },
    'adpapper-single': {
      code: 'ADPAPPER_SINGLE',
      days: 10,
      imageRequired: false,
      reason: 'shipping_rule_key',
    },
    'adpapper-eco-memo': {
      code: 'ADPAPPER_ECO_MEMO',
      days: 15,
      imageRequired: false,
      reason: 'shipping_rule_key',
    },
    'adpapper-general': {
      code: 'ADPAPPER_GENERAL',
      days: 7,
      imageRequired: false,
      reason: 'shipping_rule_key',
    },
  };


  /**
   * custom.estimated_ship_rule_key 우선 룰
   * 주문 후 배송예정일 워커와 상품 페이지 표시값을 맞추기 위한 전용 룰입니다.
   */
  const ESTIMATED_SHIP_RULE_KEY_RULES = {
    sample_3: {
      code: 'SAMPLE_3',
      days: 3,
      imageRequired: false,
      reason: 'estimated_ship_rule_key',
      useOrderDateAsBase: true,
    },
    default_10: {
      code: 'DEFAULT_10',
      days: 10,
      imageRequired: true,
      reason: 'estimated_ship_rule_key',
    },
    fusen_standard_14: {
      code: 'FUSEN_STANDARD_14',
      days: 14,
      imageRequired: true,
      reason: 'estimated_ship_rule_key',
    },
    fusen_diecut_20: {
      code: 'FUSEN_DIECUT_20',
      days: 20,
      imageRequired: true,
      reason: 'estimated_ship_rule_key',
    },
    fusen_smalllot_15: {
      code: 'FUSEN_SMALLLOT_15',
      days: 15,
      imageRequired: true,
      reason: 'estimated_ship_rule_key',
    },
  };

  const JAPAN_HOLIDAY_FALLBACKS = {
    2026: [
      '2026-01-01', '2026-01-12', '2026-02-11', '2026-02-23', '2026-03-20',
      '2026-04-29', '2026-05-03', '2026-05-04', '2026-05-05', '2026-05-06',
      '2026-07-20', '2026-08-11', '2026-09-21', '2026-09-22', '2026-09-23',
      '2026-10-12', '2026-11-03', '2026-11-23',
    ],
    2027: [
      '2027-01-01', '2027-01-11', '2027-02-11', '2027-02-23', '2027-03-21',
      '2027-03-22', '2027-04-29', '2027-05-03', '2027-05-04', '2027-05-05',
      '2027-07-19', '2027-08-11', '2027-09-20', '2027-09-23', '2027-10-11',
      '2027-11-03', '2027-11-23',
    ],
  };

  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function includesAny(text, keywords) {
    return (keywords || []).some((keyword) =>
      text.includes(String(keyword).toLowerCase())
    );
  }

  function hasAnyExactTag(tags, targets) {
    const tagSet = new Set((Array.isArray(tags) ? tags : []).map((tag) => normalizeText(tag)));
    return (Array.isArray(targets) ? targets : []).some((tag) =>
      tagSet.has(normalizeText(tag))
    );
  }


  function getProductHandleFromPage(meta, sectionEl) {
    const candidates = [];

    candidates.push(meta?.handle);
    candidates.push(meta?.productHandle);

    const productInfo = sectionEl?.closest?.('product-info') || sectionEl;
    candidates.push(productInfo?.dataset?.url);
    candidates.push(productInfo?.getAttribute?.('data-url'));
    candidates.push(window.location?.pathname || '');
    candidates.push(document.querySelector('link[rel="canonical"]')?.href || '');
    candidates.push(document.querySelector('meta[property="og:url"]')?.content || '');

    for (const raw of candidates) {
      const value = String(raw || '').trim();
      if (!value) continue;

      const match = value.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) return normalizeText(decodeURIComponent(match[1]));

      if (/^(69426|55718|55721)$/i.test(value)) return normalizeText(value);
    }

    return '';
  }

  function isSampleProductMeta(meta, shippingRuleKey, estimatedShipRuleKey, sectionEl) {
    if (estimatedShipRuleKey === 'sample_3') return true;
    if (shippingRuleKey === 'sample_600') return true;
    if (meta?.isSample === true || normalizeText(meta?.isSample) === 'true') return true;

    const handle = getProductHandleFromPage(meta, sectionEl);
    if (['69426', '55718', '55721'].includes(handle)) return true;

    const titleCandidates = [
      meta?.title,
      document.querySelector('h1')?.textContent,
      document.title,
    ];
    const title = normalizeText(titleCandidates.filter(Boolean).join(' / '));

    if (title.includes('サンプル') || title.includes('sample')) return true;

    return false;
  }

  function safeJsonParse(raw, fallback) {
    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  }

  function getDateTimePartsInTokyo(date) {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TOKYO_TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    });

    const parts = formatter.formatToParts(date);
    const map = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return map;
  }

  function getTokyoNowInfo() {
    const parts = getDateTimePartsInTokyo(new Date());
    return {
      ymd: `${parts.year}-${parts.month}-${parts.day}`,
      hour: Number(parts.hour || 0),
      minute: Number(parts.minute || 0),
    };
  }

  function addCalendarDays(ymd, days) {
    const [y, m, d] = ymd.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    dt.setUTCDate(dt.getUTCDate() + days);
    return [
      String(dt.getUTCFullYear()).padStart(4, '0'),
      String(dt.getUTCMonth() + 1).padStart(2, '0'),
      String(dt.getUTCDate()).padStart(2, '0'),
    ].join('-');
  }

  function isBusinessDay(ymd, holidaySet) {
    const dt = new Date(`${ymd}T00:00:00Z`);
    const day = dt.getUTCDay();
    if (day === 0 || day === 6) return false;
    if (holidaySet && holidaySet.has(ymd)) return false;
    return true;
  }

  function getNextBusinessDay(ymd, holidaySet) {
    let cursor = String(ymd || '');
    if (!cursor) return cursor;

    do {
      cursor = addCalendarDays(cursor, 1);
    } while (!isBusinessDay(cursor, holidaySet));

    return cursor;
  }

  function calculateBusinessDate(baseYmd, businessDays, holidaySet) {
    let cursor = String(baseYmd || '');
    let remaining = Number(businessDays || 0);

    if (!cursor || !remaining || remaining < 0) {
      return baseYmd;
    }

    while (remaining > 0) {
      cursor = addCalendarDays(cursor, 1);
      if (isBusinessDay(cursor, holidaySet)) remaining -= 1;
    }

    return cursor;
  }

  function isKrLunarHoliday(item) {
    const text = `${item?.name || ''} ${item?.localName || ''}`;
    return /설날|추석|Seollal|Chuseok|Korean New Year|Korean New Year's Day/i.test(text);
  }

  function getJapanHolidayFallbackDates(year) {
    return Array.isArray(JAPAN_HOLIDAY_FALLBACKS[year]) ? JAPAN_HOLIDAY_FALLBACKS[year] : [];
  }

  async function fetchHolidayList(year, countryCode) {
    const key = `${HOLIDAY_CACHE_PREFIX}${countryCode}-${year}`;

    try {
      const cached = sessionStorage.getItem(key);
      if (cached) {
        const parsed = safeJsonParse(cached, null);
        if (Array.isArray(parsed)) return parsed;
      }
    } catch (error) {}

    const res = await fetch(
      `https://date.nager.at/api/v3/PublicHolidays/${year}/${countryCode}`,
      {
        headers: { Accept: 'application/json' },
      }
    );

    if (!res.ok) {
      throw new Error(`holiday api failed: ${countryCode}-${year} (${res.status})`);
    }

    const data = await res.json();

    try {
      sessionStorage.setItem(key, JSON.stringify(data));
    } catch (error) {}

    return Array.isArray(data) ? data : [];
  }

  async function getHolidayListSafe(year, countryCode) {
    try {
      return await fetchHolidayList(year, countryCode);
    } catch (error) {
      console.warn('[estimated_ship_holiday_fetch_failed]', {
        countryCode,
        year,
        message: String(error?.message || error),
      });
      return [];
    }
  }

  async function buildHolidaySet(baseYmd) {
    const baseYear =
      Number(String(baseYmd || '').slice(0, 4)) || new Date().getFullYear();
    const years = [baseYear, baseYear + 1];
    const holidaySet = new Set();

    for (const year of years) {
      const jp = await getHolidayListSafe(year, 'JP');
      jp.forEach((item) => {
        if (item?.date) holidaySet.add(item.date);
      });

      getJapanHolidayFallbackDates(year).forEach((date) => holidaySet.add(date));

      const kr = await getHolidayListSafe(year, 'KR');
      kr.forEach((item) => {
        if (item?.date && isKrLunarHoliday(item)) holidaySet.add(item.date);
      });
    }

    return holidaySet;
  }

  function getHolidaySet(baseYmd) {
    const baseYear =
      Number(String(baseYmd || '').slice(0, 4)) || new Date().getFullYear();
    const cacheKey = `${baseYear}-${baseYear + 1}`;

    if (!HOLIDAY_SET_PROMISE_CACHE.has(cacheKey)) {
      HOLIDAY_SET_PROMISE_CACHE.set(
        cacheKey,
        buildHolidaySet(baseYmd).catch((error) => {
          HOLIDAY_SET_PROMISE_CACHE.delete(cacheKey);
          throw error;
        })
      );
    }

    return HOLIDAY_SET_PROMISE_CACHE.get(cacheKey);
  }

  function formatDateJa(ymd) {
    const [y, m, d] = String(ymd || '').split('-').map(Number);
    if (!y || !m || !d) return '';

    const date = new Date(Date.UTC(y, m - 1, d));
    return new Intl.DateTimeFormat('ja-JP', {
      timeZone: TOKYO_TZ,
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
    }).format(date);
  }

  function parseCountFromText(value) {
    const text = String(value || '').replace(/,/g, '');
    const match = text.match(/(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : 0;
  }

  function getCurrentVariant(sectionEl, variants) {
    const idInput = sectionEl.querySelector('input[name="id"]');
    const variantId = String(idInput?.value || '');
    if (!variantId) return null;
    return variants.find((variant) => String(variant.id) === variantId) || null;
  }

  function getSelectedMousepadCount(meta, options, variants, sectionEl) {
    const quantityIndex = (options || []).findIndex(
      (name) => normalizeText(name) === normalizeText('数量')
    );

    if (quantityIndex >= 0) {
      const variant = getCurrentVariant(sectionEl, variants || []);
      if (variant && Array.isArray(variant.options)) {
        return parseCountFromText(variant.options[quantityIndex]);
      }
    }

    const selected = sectionEl.querySelectorAll('input:checked, select option:checked');
    for (const el of selected) {
      const text = el.value || el.textContent || '';
      const count = parseCountFromText(text);
      if (count > 0) return count;
    }

    return 0;
  }

  function resolveOrderBaseYmd(todayYmd, holidaySet, hour, minute) {
    const isAfterCutoff =
      hour > ORDER_CUTOFF_HOUR ||
      (hour === ORDER_CUTOFF_HOUR && minute > 0);

    if (!isAfterCutoff) return todayYmd;
    return getNextBusinessDay(todayYmd, holidaySet);
  }

  function resolveRule(meta, options, variants, sectionEl) {
    /**
     * 1순위: 샘플 상품
     * - sample_3 / sample_600 / is_sample / 샘플 핸들·상품명 fallback
     * - 주문일 기준 3영업일, 15시 컷오프를 적용하지 않음
     */
    const estimatedShipRuleKey = normalizeText(meta?.estimatedShipRuleKey || '');
    const shippingRuleKey = normalizeText(meta?.shippingRuleKey || '');

    if (isSampleProductMeta(meta, shippingRuleKey, estimatedShipRuleKey, sectionEl)) {
      return ESTIMATED_SHIP_RULE_KEY_RULES.sample_3;
    }

    /**
     * 2순위: custom.estimated_ship_rule_key
     * - 주문 후 배송예정일 워커와 동일한 전용 메타필드를 우선 적용
     */

    if (estimatedShipRuleKey === 'mousepad_qty_based') {
      const sheetCount = getSelectedMousepadCount(meta, options, variants, sectionEl);

      if (sheetCount > 0 && sheetCount <= 500) {
        return {
          code: 'MOUSEPAD_UNDER_500_13',
          days: 13,
          imageRequired: true,
          reason: 'estimated_ship_rule_key',
          sheetCount,
        };
      }

      return {
        code: 'MOUSEPAD_10',
        days: 10,
        imageRequired: true,
        reason: 'estimated_ship_rule_key',
        sheetCount,
      };
    }

    if (estimatedShipRuleKey && ESTIMATED_SHIP_RULE_KEY_RULES[estimatedShipRuleKey]) {
      return ESTIMATED_SHIP_RULE_KEY_RULES[estimatedShipRuleKey];
    }

    /**
     * 3순위: custom.shipping_rule_key
     * - 구형 상품 페이지/CSV fallback 대응
     */
    if (shippingRuleKey && SHIPPING_RULE_KEY_RULES[shippingRuleKey]) {
      return SHIPPING_RULE_KEY_RULES[shippingRuleKey];
    }

    /**
     * 4순위: 기존 태그/상품명 fallback 유지
     */
    const title = String(meta?.title || '');
    const type = String(meta?.type || '');
    const collections = Array.isArray(meta?.collections) ? meta.collections : [];
    const tags = Array.isArray(meta?.tags) ? meta.tags : [];
    const hasTemplateDownload = meta?.hasTemplateDownload === true;

    const haystack = normalizeText([
      title,
      type,
      collections.join(' '),
      tags.join(' '),
    ].join(' / '));

    if (
      hasAnyExactTag(tags, ['マウスパッド']) ||
      includesAny(haystack, ['マウスパッド', 'mousepad', 'mouse pad'])
    ) {
      const sheetCount = getSelectedMousepadCount(meta, options, variants, sectionEl);

      if (sheetCount > 0 && sheetCount <= 500) {
        return {
          code: 'MOUSEPAD_UNDER_500_13',
          days: 13,
          imageRequired: hasTemplateDownload,
          reason: 'tag:マウスパッド_under_500',
          sheetCount,
        };
      }

      return {
        code: 'MOUSEPAD_10',
        days: 10,
        imageRequired: hasTemplateDownload,
        reason: 'tag:マウスパッド',
        sheetCount,
      };
    }

    for (const rule of TAG_RULES) {
      if (hasAnyExactTag(tags, rule.tags)) {
        return {
          code: rule.code,
          days: rule.days,
          imageRequired: rule.imageRequired,
          reason: 'tag',
        };
      }
    }

    if (includesAny(haystack, ['型抜きふせん', '型抜き ふせん', 'katanuki-fusen', 'katanukifusen'])) {
      return {
        code: 'FUSEN_DIECUT_20',
        days: 20,
        imageRequired: true,
        reason: 'fallback',
      };
    }

    if (includesAny(haystack, ['小ロットショップ', '小ロットふせん', '小ロット ふせん', 'shorotto-fusen', 'smalllot-fusen'])) {
      return {
        code: 'FUSEN_SMALLLOT_15',
        days: 15,
        imageRequired: true,
        reason: 'fallback',
      };
    }

    if (includesAny(haystack, ['一般付箋', 'カバー付き付箋', '台紙付箋', '一般ふせん', 'カバー付きふせん', '台紙付きふせん'])) {
      return {
        code: 'FUSEN_STANDARD_14',
        days: 14,
        imageRequired: true,
        reason: 'fallback',
      };
    }

    return {
      code: 'DEFAULT_10',
      days: 10,
      imageRequired: hasTemplateDownload,
      reason: 'default',
    };
  }

  function buildMessage(rule, ymd) {
    const formattedDate = formatDateJa(ymd);
    if (!formattedDate) return '発送予定日を計算できませんでした。';

    if (rule.imageRequired) {
      return `${formattedDate}ごろ出荷予定（ご注文・データ確認後）`;
    }

    return `${formattedDate}ごろ出荷予定（ご注文後）`;
  }

  function readMeta(sectionId) {
    const metaEl = document.getElementById(`EunchangEstimatedShipMeta-${sectionId}`);
    const optionsEl = document.getElementById(`EunchangProductOptions-${sectionId}`);
    const variantsEl = document.getElementById(`EunchangProductVariants-${sectionId}`);

    const meta = safeJsonParse(metaEl?.textContent || '{}', {});
    const options = safeJsonParse(optionsEl?.textContent || '[]', []);
    const variants = safeJsonParse(variantsEl?.textContent || '[]', []);

    return { meta, options, variants };
  }

  function buildCalcKey(rule, variant, todayYmd, baseYmd) {
    return [
      SCRIPT_VERSION,
      todayYmd,
      baseYmd,
      rule.code,
      rule.days,
      rule.imageRequired ? '1' : '0',
      rule.sheetCount || 0,
      variant?.id || '',
    ].join('|');
  }

  async function updateEstimatedShip(root) {
    const textEl = root.querySelector('[data-estimated-ship-text]');
    if (!textEl) return;

    const sectionId = String(root.dataset.sectionId || '');
    const sectionEl =
      document.getElementById(`ProductInfo-${sectionId}`)?.closest('product-info') ||
      root.closest('product-info');

    if (!sectionId || !sectionEl) return;

    const { meta, options, variants } = readMeta(sectionId);
    const variant = getCurrentVariant(sectionEl, variants);
    const rule = resolveRule(meta, options, variants, sectionEl);
    const nowInfo = getTokyoNowInfo();
    const todayYmd = nowInfo.ymd;

    const seq = String((Number(root.dataset.seq || '0') || 0) + 1);
    root.dataset.seq = seq;

    const loadingText = '発送予定日を計算しています...';
    const hasPreviousEstimate = Boolean(root.dataset.estimatedDate);

    if (!hasPreviousEstimate) {
      textEl.textContent = loadingText;
    }

    let holidaySet = new Set();
    try {
      holidaySet = await getHolidaySet(todayYmd);
    } catch (error) {
      const baseYear = Number(String(todayYmd || '').slice(0, 4)) || new Date().getFullYear();
      [...getJapanHolidayFallbackDates(baseYear), ...getJapanHolidayFallbackDates(baseYear + 1)]
        .forEach((date) => holidaySet.add(date));
    }

    if (root.dataset.seq !== seq) return;

    const baseYmd = rule.useOrderDateAsBase
      ? todayYmd
      : resolveOrderBaseYmd(
          todayYmd,
          holidaySet,
          nowInfo.hour,
          nowInfo.minute
        );

    const calcKey = buildCalcKey(rule, variant, todayYmd, baseYmd);

    if (root.dataset.calcKey === calcKey && root.dataset.estimatedDate) {
      const restoredMessage = buildMessage(rule, root.dataset.estimatedDate);
      if (!textEl.textContent || textEl.textContent === loadingText) {
        textEl.textContent = restoredMessage;
      }
      return;
    }

    const targetYmd = calculateBusinessDate(baseYmd, rule.days, holidaySet);
    textEl.textContent = buildMessage(rule, targetYmd);

    root.dataset.calcKey = calcKey;
    root.dataset.scriptVersion = SCRIPT_VERSION;
    root.dataset.ruleCode = rule.code;
    root.dataset.ruleReason = rule.reason || '';
    root.dataset.businessDays = String(rule.days);
    root.dataset.baseYmd = baseYmd;
    root.dataset.estimatedDate = targetYmd;
  }

  function bindEstimatedShip(root) {
    const sectionId = String(root.dataset.sectionId || '');
    const productInfo =
      document.getElementById(`ProductInfo-${sectionId}`)?.closest('product-info') ||
      root.closest('product-info');

    if (!sectionId || !productInfo) return;
    if (root.dataset.boundVersion === SCRIPT_VERSION) return;

    root.dataset.bound = 'true';
    root.dataset.boundVersion = SCRIPT_VERSION;

    const rerender = () => {
      window.clearTimeout(root._estimatedShipTimer);
      root._estimatedShipTimer = window.setTimeout(() => {
        updateEstimatedShip(root);
      }, 120);
    };

    productInfo.addEventListener('change', rerender);

    const idInput = productInfo.querySelector('input[name="id"]');
    if (idInput) {
      const observer = new MutationObserver(rerender);
      observer.observe(idInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
      root._estimatedShipObserver = observer;
    }

    updateEstimatedShip(root);
    window.setTimeout(() => updateEstimatedShip(root), 300);
    window.setTimeout(() => updateEstimatedShip(root), 1200);
  }

  function initEstimatedShip(scope) {
    const roots = (scope || document).querySelectorAll('[data-estimated-ship]');
    roots.forEach(bindEstimatedShip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initEstimatedShip(document));
  } else {
    initEstimatedShip(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initEstimatedShip(event.target);
  });
})();